<template>
    <div class="wrap">
        <div class="containter">
            <type-menu ref="typeMenu" no-edit @onChangeMenu="onChangeMenu"></type-menu>
            <div class="content" v-loading="loading">
                <div class="c-header">
                    <div class="header-group-left">
                    </div>
                    <div class="header-group-right">
                        <div>
                            <el-input placeholder="请输入内容" v-model="query.keyword" class="input-with-select" size="mini">
                                <el-button slot="append" icon="el-icon-search" @click="getList"></el-button>
                            </el-input>
                        </div>
                    </div>
                </div>

                <div class="c-main">
                    <div class="overflow-container">
                        <el-table :data="list" style="width: 100%" @selection-change="handleSelectionChange">
                            <el-table-column type="selection" width="55">
                            </el-table-column>
                            <el-table-column prop="title" label="标题" width="200" show-overflow-tooltip>
                            </el-table-column>
                            <el-table-column label="封面" width="120">
                                <template slot-scope="scope">
                                    <el-image :src="scope.row.cover" :preview-src-list="[scope.row.cover]"> </el-image>
                                </template>
                            </el-table-column>
                            <el-table-column  label="标签" min-width="150" align="center">
                                <template slot-scope="scope"  >
                                    <el-tag size="medium" :key="item" v-for="item in scope.row.tags" class="tag">
                                        {{ item }}
                                    </el-tag>
                                </template>
                            </el-table-column>
                            <el-table-column label="直播状态" >
                                <template slot-scope="scope">
                                    <el-tag :type="statusStyle(scope.row.status)" size="mini">{{
                                        scope.row.status
                                        }}</el-tag>
                                </template>
                            </el-table-column>
                            <el-table-column prop="liveTime" label="开始时间" width="200" show-overflow-tooltip>
                            </el-table-column>
                            <el-table-column prop="overTime" label="结束时间" width="200" show-overflow-tooltip>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="page">
                        <el-pagination class="" @current-change="handleCurrentChange" :current-page="query.page"
                            :page-sizes="[10, 20, 50, 100]" :page-size="query.pageSize"
                            layout="total, prev, pager, next, jumper" :total="query.total">
                        </el-pagination>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import { getLiveList } from "@/api/material"
import TypeMenu from "./TypeMenu.vue"

export default {
    components: {
        TypeMenu,
    },
    data() {
        const validatePrice = (rule, value, callback) => {
            const reg = /^\d+(\.\d{1,2})?$/;
            if (value === '') {
                callback();
            } else if (!reg.test(value)) {
                callback(new Error('请输入正确的价格格式，最多两位小数'));
            } else {
                callback();
            }
        };
        return {
            checked: false,
            loading: true,
            list: [],
            category: "",
            subCategory: void 0,
            query: {
                page: 1,
                total: 0,
                pageSize: 10,
                keyword: ''
            },
        };
    },
    computed: {
        delAccess() {
            return this.list.some(item => item.checked === true);
        },
    },
    watch: {
        list: {
            handler(val) {
                if (val.length === 0) {
                    this.checked = false;
                    return
                }
                const tag = val.every((item) => item.checked === true);

            },
            deep: true,
        },
    },
    methods: {
        statusStyle(status) {
            return {
                '直播中': '',
                '未开始': 'warning',
                '已结束': 'info',
            }[status]
        },
        onChangeMenu({ id, cid }) {
            this.category = id;
            this.subCategory = cid;
            this.query = {
                page: 1,
                total: 0,
                pageSize: 10,
                keyword: ''
            };
            this.getList();
        },
        async initList() {
            await this.getList();
        },

        async getList() {
            try {

                this.loading = true;
                const { page, pageSize } = this.query;
                const { status, data, message } = await getLiveList({
                    category: this.category,
                    subCategory: this.subCategory,
                    page: page,
                    pageSize: pageSize,
                    title: this.query.keyword,
                });
                if (status == 10000) {
                    this.list = data.rooms.map((item) => {
                        return {
                            checked: false,
                            ...item,
                        };
                    });
                    this.query.total = data.total;
                } else {
                    throw new Error(message);
                }
            } catch (error) {
                this.$message.error(error || '获取数据失败');
            } finally {
                this.loading = false;
            }
        },

        handleCurrentChange(page) {
            this.query.page = page;
            this.getList();
        },

        handleSelectionChange(val) {
            const liveData = val.map((item) => {
                return {
                    id: item._id,
                    title: item.title,
                    image: item.cover,
                    liveUrl: item.liveUrl,
                    watchCount: item.views,
                    sourceType: '直播',
                    status: item.status,
                    liveTime: item.liveTime,
                    overTime: item.overTime,
                }
            });
            this.$emit('onChangeSelection', liveData);
        },

    },
};
</script>
<style lang="scss" scoped>
.wrap {
    width: 100%;
    height: 500px;

    .containter {
        width: 100%;
        height: 100%;
        display: flex;
        padding: 8px;

        .content {
            flex: 1 1 auto;
            min-width: 0;
            height: 100%;
            display: flex;
            flex-direction: column;
            padding: 0 0 10px 16px;
        }

        .c-header {
            display: flex;
            height: 32px;
            justify-content: space-between;
            align-items: center;

            &:nth-of-type(2n) {
                margin-top: 8px;
            }
        }

        .header-group-left {
            .el-button {
                min-width: 80px;

                &:first-child {
                    margin-right: 8px;
                }
            }
        }

        .c-main {
            position: relative;
            flex: 1 1 auto;
            min-height: auto;
            padding: 6px 0 42px;
            height: 100%;

            .overflow-container {
                height: 100%;
                overflow-y: auto;

                // 滚动条整体样式
                &::-webkit-scrollbar {
                    display: block;
                    width: 6px;
                    height: 6px;
                }

                // 滚动条轨道
                &::-webkit-scrollbar-track {
                    background: #f1f1f1;
                    border-radius: 3px;
                }

                // 滚动条滑块
                &::-webkit-scrollbar-thumb {
                    background: #c1c1c1;
                    border-radius: 3px;

                    &:hover {
                        background: #a8a8a8;
                    }
                }
            }

            .page {
                display: flex;
                justify-content: flex-end;
                position: absolute;
                bottom: 6px;
                width: 100%;
            }
        }

    }
}

.article-form {
    width: 100%;
    display: flex;
    gap: 24px;
}

.article-form-left {
    width: 800px;
}

.article-form-right {
    width: 300px;
}

.form-iframe {
    width: 100%;
    height: calc(100vh - 114px);
}

.tag {
    margin-top: 4px;
    & + .tag {
        margin-left: 4px;
    }
}
</style>
